import BlazeSlider from "blaze-slider";

const BannerSlider = () => {
  const banner = document.querySelectorAll(".banner-slider");

  if (banner.length) {
    banner.forEach((item) => {
      const slider = new BlazeSlider(item, {
        all: {
          enableAutoplay: true,
          autoplayInterval: 5000,
          transitionDuration: 1000,
          transitionTimingFunction: "cubic-bezier(0.33, 1, 0.68, 1)",
          slidesToShow: 1,
        },
      });

      const totalSlides = slider.slides.length;

      const paginationContainers = item.querySelector(".pagination-container");

      //Create pagination buttons based on number of slides
      for (i = 0; i < totalSlides; i++) {
        const slideNumber = i < 9 ? "0" + (i + 1) : i + 1; // Prepend '0' if less than 10
        const button = document.createElement("button");
        button.classList.add("pagination-btn");
        if (i == 0) {
          button.classList.add("active");
        }
        button.textContent = slideNumber;
        button.dataset.slideNum = i;
          paginationContainers.appendChild(button.cloneNode(true));
      }

      const buttons = item.querySelectorAll(".pagination-btn");

      //Change active button on slide
      slider.onSlide((pageIndex) => {
        buttons.forEach((button) => {
          if (button.dataset.slideNum == pageIndex) {
            button.classList.add("active");
          } else {
            button.classList.remove("active");
          }
        });
      });

      //Change slide on click
      buttons.forEach((button) => {
        button.addEventListener("click", function () {

          //Rewritten from blazeslider utils pagination
          const currentIndex = this.dataset.slideNum;
          const stateIndex = slider.stateIndex;

          const diff = Math.abs(currentIndex - stateIndex);
          const inverseDiff = slider.states.length - diff;
          const isDiffLargerThanHalf = diff > slider.states.length / 2;
          const scrollOpposite = isDiffLargerThanHalf;

          if (currentIndex > stateIndex) {
            // but the diff is too large
            if (scrollOpposite) {
              // scroll in opposite direction to reduce scrolling
              slider.prev(inverseDiff);
            } else {
              // scroll normally
              slider.next(diff);
            }
          }
          // if target state is before current state
          else {
            // but the diff is too large
            if (scrollOpposite) {
              // scroll in opposite direction
              slider.next(inverseDiff);
            } else {
              // scroll normally
              slider.prev(diff);
            }
          }
        });
      });
    });
  }
};

export default BannerSlider;
